<template>
    <v-layout justify-center wrap>
        <v-flex xs12 md8>
            <material-card
                    color="red"
                    title="401 - Unauthorized">
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                            <v-icon>mdi-block-helper</v-icon>
                            You are not authorized to visit this page
                        </v-flex>
                    </v-layout>
                    <small>Go back to <router-link to="/dashboard">Dashboard</router-link></small>
                </v-container>

            </material-card>
        </v-flex>
    </v-layout>

</template>

<script>
    export default {
        data() {
            return {}
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
